import Autocomplete from "@mui/joy/Autocomplete"
import React from "react"
import SearchIcon from "@mui/icons-material/Search"

const ClubsSearch = ({ clubs }: { clubs: { name: string; id: number; city: string }[] }) => {
  const countOfClubsPerCity = clubs.reduce((acc, club) => {
    acc[club.city] = (acc[club.city] || 0) + 1
    return acc
  }, {} as Record<string, number>)
  const sortedCities = Object.entries(countOfClubsPerCity).sort((a, b) => b[1] - a[1])
  const clubOptions = clubs.map((club) => ({
    id: club.id.toString(),
    label: club.name.toLowerCase(),
    url: `/clubs/${club.id}`,
  }))
  const cityOptions = sortedCities.map(([city, _count]) => ({
    id: city,
    label: city.toLowerCase(),
    url: `/clubs?city=${city}`,
  }))
  const autocompleteOptions = [...cityOptions, ...clubOptions]

  return (
    <Autocomplete
      getOptionKey={(option) => (typeof option === "string" ? option : option.id)}
      startDecorator={<SearchIcon />}
      freeSolo
      size="lg"
      placeholder="Rechercher par club ou ville"
      options={autocompleteOptions}
      onChange={(_event, value) => {
        if (value && typeof value === "object" && "url" in value) {
          window.location.href = value.url
        } else {
          window.location.href = `/clubs?query=${value}`
        }
      }}
    />
  )
}

export default ClubsSearch
